<template>
  <div>
    <p
      class="flex items-center justify-center p-3 bg-gray-200 text-gray-700 rounded cursor-pointer"
      v-click-outside="clickedOutsideLink"
    >
      <ion-icon name="call" class="mr-2" />
      {{ result.value.display || result.value }}
    </p>

    <table class="w-full text-left spaced-table">
      <tr>
        <th>Day</th>
        <th class="text-right">Hours</th>
      </tr>
      <tr v-for="(day, dIndex) in days" :key="dIndex">
        <td>{{ formatDate(day.date) }}</td>
        <td class="text-right">
          <div
            v-for="(available, aIndex) in day.available"
            :key="aIndex"
            v-html="formatTimeWindow(available)"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Hours",
  props: {
    href: String,
    result: Object,
  },
  data() {
    return {
      daysOfWeek: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
    };
  },
  computed: {
    days() {
      return this.result?.hours?.days;
    },
    end() {
      return this.days.map(day =>
        day.available.map(av => (this.isClosed(av) ? "" : av.split("-")[1])),
      );
    },
    start() {
      return this.days.map(day =>
        day.available.map(av =>
          this.isClosed(av) ? "Closed" : av.split("-")[0],
        ),
      );
    },
  },
  methods: {
    clickedOutsideLink(e) {
      // stop the click outside of this element from triggering the phone call
      // that the a tag in the parent component would normally trigger, letting
      // only this element being clicked on cause the phone dial event
      e.preventDefault();
    },
    formatDate(date) {
      const momentDate = moment(date);
      const numberedDayOfWeek = momentDate.weekday();
      const isToday = moment().isSame(momentDate, "day");
      const isTomorrow = moment()
        .add(1, "days")
        .isSame(momentDate, "day");
      if (isToday) return "Today";
      if (isTomorrow) return "Tomorrow";
      return this.daysOfWeek[numberedDayOfWeek];
    },
    formatTime(time) {
      if (time.endsWith(":00")) return time.slice(0, -3);
      return time;
    },
    formatTimeWindow(timeWindow) {
      if (this.isClosed(timeWindow)) return "Closed";
      const windows = timeWindow.split("-");
      return `${this.formatTime(windows[0])} &mdash; ${this.formatTime(
        windows[1],
      )}`;
    },
    isClosed(timeWindow) {
      return timeWindow === "00:00:00-00:00:00";
    },
  },
};
</script>

<style lang="scss">
.spaced-table {
  td,
  th {
    @apply p-1;
  }
}
</style>
